import { useNavigate } from 'react-router-dom';
import { useCallback, useEffect } from 'react';
import { ClbLoading } from '@celebration/react/ClbLoading/ClbLoading';
import Auth from '../../app/contexts/auth';
import WelcomeConstants from '../welcome/constants';
import HomeConstants from '../home/constants';
import './login.scss';

export default function Login() {
    const { user, isFetchingToken, loginByCode } = Auth.useAuth();
    const navigate = useNavigate();

    const fetchUser = useCallback(async () => {
        if (user) {
            navigate(HomeConstants.PATH);
        } else if (isFetchingToken) {
            await loginByCode();
        } else {
            navigate(WelcomeConstants.default);
        }
    }, [isFetchingToken, user, loginByCode, navigate]);

    useEffect(() => {
        fetchUser();
    }, [fetchUser]);

    return (
        <div className="loading" data-testid="login-loading">
            <ClbLoading size="lg" />
        </div>
    );
}
